import { ApiUtils, _axios } from "@/api/apiUtil.js";
import constant from "@/util/constant.js";
const api = {
  list: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/sprint/sprintBoard/list",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  headList: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/sprint/sprintBoard/headList",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  chartlist: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/sprint/sprintBoard/chartlist",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  tendlist:(params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/sprint/sprintBoard/tendlist",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
};
export default api;
